"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextTimeBefore = void 0;
var TIME_TOLERANCE_IN_SECONDS = 3;
var getNextTimeBefore = function (nextTime, rotations) {
    if (!rotations.length) {
        return nextTime.clone().subtract(TIME_TOLERANCE_IN_SECONDS, "seconds");
    }
    var lastRotation = rotations[rotations.length - 1];
    var lastMediafile = lastRotation.mediafile;
    var nextTimeBefore = nextTime.clone().subtract(lastMediafile === null || lastMediafile === void 0 ? void 0 : lastMediafile.duration, "milliseconds");
    if (nextTimeBefore.isSameOrBefore(lastRotation.playtime)) {
        return lastRotation.playtime.clone();
    }
    return nextTimeBefore;
};
exports.getNextTimeBefore = getNextTimeBefore;
//# sourceMappingURL=getNextTimeBefore.js.map